module.exports = __webpack_public_path__ + "img/interaction.0bbf1e65.svg";